import React, { useCallback } from 'react';
import ScreenChatPanel from 'components/ai/ScreenChatPanel';
import { handleType1Chat } from 'expense/type1ChatEngine';

const WELCOME =
  '로그인 기관 지출결의(type1)만 조회·연결·저장·삭제할 수 있습니다.\n예) 사용일 20260130 법인카드사용내역을 채주내역에 추가해줘\n예) 스타벅스 증빙을 문화 사업 과목 210에 연결해줘';

/**
 * 지출결의등록(type1) 우측 챗봇 — LLM 없이 규칙 파서
 */
export default function ExpenseType1ChatPanel({ prefsUserId, getContext, onDone }) {
  const send = useCallback(
    async (payload) => {
      const ctx = typeof getContext === 'function' ? getContext() : {};
      return await handleType1Chat({
        message: payload?.message || '',
        confirm: !!payload?.confirm,
        previewId: payload?.previewId || '',
        ctx,
      });
    },
    [getContext]
  );

  return (
    <ScreenChatPanel
      title="챗봇"
      hint="로그인 기관만 · 쓰기는 확인 후 반영"
      welcome={WELCOME}
      placeholder="사용일 20260130 법인카드사용내역을 채주내역에 추가해줘"
      storagePrefix="expenseType1ChatCollapsed"
      prefsUserId={prefsUserId}
      send={send}
      onDone={onDone}
    />
  );
}
